import { addDays } from 'date-fns'
import { useQuery } from '@tanstack/react-query'
import { MC_POSTCODE } from '@mindfulchefuk/constants'
import { getDateDeliverabilities } from '@mindfulchefuk/features/Delivery/services/getDateDeliverabilities'
import { dateFormats } from '@mindfulchefuk/lib/dateFormats'

export const useQueryHomepageDateAvailabilities = () => {
  const startingDate = addDays(new Date(), 1)
  const endingDate = addDays(startingDate, 7)

  return useQuery({
    queryKey: ['dateDeliverabilities', dateFormats.iso(startingDate)],
    queryFn: () =>
      getDateDeliverabilities({
        minDate: dateFormats.iso(startingDate),
        maxDate: dateFormats.iso(endingDate),
        postcode: MC_POSTCODE,
      }),
    enabled: !!startingDate,
    refetchOnWindowFocus: false,
  })
}
